export default "__VITE_ASSET__cee8104e__"